import { render } from "./breadCrumb.vue?vue&type=template&id=2d58a672"
import script from "./breadCrumb.vue?vue&type=script&lang=js"
export * from "./breadCrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__